import { Component } from '@angular/core';
import { ApiService } from '../../../service/api/api.service';
import { NotificationService } from '../../../service/notification/notification.service';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { SocketService } from '../../../service/sio/socket.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  connexion_status = "En ligne";
  granted: boolean = false
  loading_update = false
  userConneceted: any
  constructor(public api: ApiService, public not: NotificationService, private swUpdate: SwUpdate, public sio: SocketService) {
    this.granted = Notification.permission === "granted"
    if (swUpdate.isEnabled) {
      // Abonnez-vous aux événements de mise à jour
      this.swUpdate.versionUpdates.subscribe((event: VersionEvent) => {
        this.loading_update = false
        if (event.type === 'VERSION_READY') {
          console.log('PWA : Une nouvelle version est disponible. Chargement de la nouvelle version... event= ', event);

          // Effectuez une vérification pour éviter les rechargements infinis
          const isUpdateReloaded = localStorage.getItem('isUpdateReloaded');
          if (!isUpdateReloaded) {
            api.Swal_success("Une nouvelle mise à jour est disponible")
            localStorage.setItem('isUpdateReloaded', 'true');
            this.swUpdate.activateUpdate().then(() => {
              window.location.reload();
            });
          } else {
            api.Swal_success("Vous avez la dernière version")
          }
        } else if (event.type === 'VERSION_INSTALLATION_FAILED') {
          console.error('PWA : La mise à jour a échoué.', event);
          api.Swal_error("Echec de mise à jour. Essayez CTL + Shif + R")
        }
      });

      // Réinitialisez le stockage local après une recharge
      window.addEventListener('load', () => {
        if (localStorage.getItem('isUpdateReloaded')) {
          localStorage.removeItem('isUpdateReloaded');
        }
      });
    }
  }
  ngOnInit() {
    this.api.mode.status = this.api.get_from_local_storage("status")
    if (this.api.mode.status) {
      this.connexion_status = "En ligne";
    } else {
      this.connexion_status = "Hors ligne"
    }

    this.userConneceted = this.api.token.user_connected
    console.log("id_employe == ", this.userConneceted.id_employe)
    this.sio.on_update((data: any) => {
      //console.log('on_change(after_add_commande,after_edit_une_commande ', data)
      this.api.les_utilisateurs = data.map((un_utilisateur: any) => {
        un_utilisateur.icone = "bx-user"
        if (un_utilisateur.token) {
          un_utilisateur.token_decoded = this.api.decode_token(un_utilisateur.token)
          un_utilisateur.titre = "E°" + un_utilisateur?.token_decoded?.user_connected?.id_employe + "-" + un_utilisateur?.token_decoded?.user_connected?.prenom + " " + un_utilisateur?.token_decoded?.user_connected?.nom
          un_utilisateur.moi = un_utilisateur?.token_decoded?.user_connected?.id_employe == this.userConneceted.id_employe
        } else {
          un_utilisateur.titre = "Inconnu"
        }
        return un_utilisateur
      })
      //console.log("les_utilisateurs = ", this.api.les_utilisateurs)
    });
  }
  logout() {
    this.api.deconnexion();
  }
  mode_online_offline() {
    this.api.mode.status = !this.api.mode.status;
    if (this.api.mode.status) {
      this.connexion_status = "En ligne";
    } else {
      this.connexion_status = "Hors ligne"
    }
    // sauvegarde
    this.api.save_on_local_storage("status", this.api.mode.status)
  }
  checkForUpdates(): void {
    this.loading_update = true
    console.log("PWA : checkForUpdates")
    this.swUpdate.checkForUpdate();
  }
}
